import script from "./ReportViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportViewer.vue?vue&type=script&setup=true&lang=js"

import "./ReportViewer.vue?vue&type=style&index=0&id=711c9bdc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711c9bdc"]])

export default __exports__